<template>
  <div class="add-terms-wrapper">
    <div class="add-terms-tips">
      <i style="color:#FAAD14" class="el-icon-warning"></i>
      请您此处填写完毕后，前往 【运营管理-新增术语】 模块进行审核提交
    </div>
    <div>
      <el-form ref="addTermForm" :model="ruleForm" :rules="rules" size="small" label-suffix="：" label-width="140px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="添加术语名" prop="name">
              <el-input v-model="ruleForm.name" maxlength="30" placeholder="请输入术语名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标准域" prop="regionId">
              <el-select v-model="ruleForm.regionId" placeholder="请选择标准域" @change="onChangeRegion">
                <el-option v-for="item in  searchList[4].optionData" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>  
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- @change="handleChangeLevel" -->
            <el-form-item label="标准层级" :rules="[{ required: true, message: '请选择标准层级', trigger: 'blur' }]">
              <el-select v-model="parentObj" placeholder="请选择标准层级"
                class="remote-multiple-select" @change="handleChangeLevel"
                v-selectLoadmore="loadmore" :remote-method="codeRemoteMethod" value-key="id" :loading="codeLoading" clearable>
                <el-option v-for="(item,index) in levelList" :key="index" :label="item.twoLayersName" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="添加位置" prop="positionId">
              <el-select v-model="ruleForm.positionId" placeholder="请选择添加位置">
                <el-option v-for="item in  positionList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>  
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="术语类型" prop="recordType">
              <el-select v-model="ruleForm.recordType" placeholder="请选择术语类型" @change="onChangeRecordType">
                <el-option v-for="item in termTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="术语小数点" prop="accuracy" v-if="ruleForm.recordType == 'number'">
              <el-select v-model="ruleForm.accuracy" placeholder="请选择术语小数点">
                <el-option v-for="item in pointList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>  
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="术语单位" prop="unit" v-if="ruleForm.recordType == 'number'">
              <div style="display:flex;flex:1">
                <el-select v-model="ruleForm.unit" placeholder="请选择术语单位" @change="changeTermUnit">
                  <el-option v-for="(item,index) in  unitList" :key="index" :label="(item.name?item.name:'')+(item.description?item.description:'')"
                    :value="item.name">
                  </el-option>
                </el-select>
                <el-select v-model="ruleForm.unit1" v-if='ruleForm.unit !="无"' style="margin-left:10px"
                  placeholder="请选择术语单位">
                  <el-option v-for="(item,index) in  unitList" :key="index" :label="(item.name?item.name:'')+(item.description?item.description:'')"
                    :value="item.name">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="ruleForm.recordType == 'number' && ruleForm.unit != '无'" label="术语单位参考值" prop="referenceMin">
              <div class="refer-unit-value">
                <el-input v-model="ruleForm.referenceMin" size="small" placeholder="请输入最低值"/>
                <span>~</span>
                <el-input v-model="ruleForm.referenceMax" size="small" placeholder="请输入最高值"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>  
      </el-form>
      <div v-if="$route.path != '/customerRoom'" style="text-align:right;margin-bottom:10px">
        <el-button size="small" @click="handleReset">重置</el-button>
        <el-button v-if="selectRowIndex !== ''" size="small" type="primary" @click="handleAdd">保存</el-button>
        <el-button v-else size="small" type="primary" @click="handleAdd">添加</el-button>
      </div>
    </div>
    <el-tabs v-model="activeName" style="margin-bottom:20px;" @tab-click="handleTabClick">
      <el-tab-pane label="添加列表" name="first">
      </el-tab-pane>
      <el-tab-pane label="已上传" name="second">
      </el-tab-pane>
    </el-tabs>
    <!-- :height="activeName == 'first' ? '' : ''" -->
    <el-table :data="crossTermsList"
            :header-cell-style="{textAlign: 'center',color: '#333333',fontSize: '14px', fontWeight: 'bold',backgroundColor: '#FAFAFA'}"
            tooltip-effect="dark"
            :height="ruleForm.recordType == 'number' ? 'calc(100% - 400px)' : 'calc(100% - 350px)'"
            ref="multipleTable"
            fit highlight-current-row>
      <el-table-column align="center" prop="name" label="申请术语名" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" prop="result" label="申请结果">
        <template slot-scope="scope">
          <span>{{ resultObj[scope.row.state] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="regionName" label="标准域" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ optionDataObj[scope.row.regionId - 1] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="twoLayersName" label="标准层级" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="activeName == 'first'">{{ scope.row.twoLayersName }}</span>
          <span v-show="activeName == 'second'">{{ scope.row.parentTwoLayersName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="recordType" label="申请术语类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ termTypeObj[scope.row.recordType] }}</span>
        </template>
      </el-table-column> 
      <el-table-column align="center" prop="unit" label="单位" width="100">
        <template slot-scope="scope">
          <span v-show="activeName == 'first'">{{ scope.row.unit }}{{ scope.row.unit1 ? '/' + scope.row.unit1 : '' }}</span>
          <span v-show="activeName == 'second'">{{ scope.row.unit }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-show="activeName == 'first'" type="text" size="medium" @click="handleEdit(scope.row,scope.$index)">编辑</el-button>
          </template>
      </el-table-column>
    </el-table>
    <!-- <div style="text-align:center">
      <el-button size="small" class="add-item-push" type="primary" @click="handleBottomAdd">
        + 添加字段
      </el-button>
    </div> -->
    <div v-if="activeName == 'second'" style="text-align:right;margin-top:15px">
      <el-pagination background :current-page="current" :page-sizes="[10, 20, 30, 50]"
                    :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                    :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>
    <div v-show="activeName == 'first' && $route.path != '/customerRoom'" slot="footer" class="save-btn">
      <el-button size="small" type="primary" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>
<script>
import { DEEP_CLONE } from '@/utils/constants'
import {unitListData,insertTerminologyList,pageTerminologyList,termListData} from "@/api/crossreentry"
export default {
  props: {
    patientFilesItemId: {
      type: String
    }
  },
  directives: {
    selectLoadmore: {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  data() {
    return {
      resultObj: {
        added: '已添加',
        merged: '已合并',
        draft: ''
      },
      activeName: 'first',
      parentObj: {},
      optionDataObj: ['基本信息','体格','检查','检验','病史'],
      termTypeObj: {
        number: "数字",
        string: '文本',
        date: '日期'
      },
      searchList: [
        {
          label: "来源平台",
          value: 1,
          paramName: "source",
          inputType: "select",
          optionData: [
            {
              label: "科研平台",
              value: "科研平台"
            }
          ]
        },
        {
          label: "来源数据",
          value: 2,
          paramName: "csvInfo",
          inputType: "input"
        },
        {
          label: "申请术语名",
          value: 3,
          paramName: "name",
          inputType: "input"
        },
        {
          label: "原术语名",
          value: 4,
          paramName: "oldName",
          inputType: "input"
        },
        {
          label: "标准域",
          value: 5,
          paramName: "regionId",
          inputType: "select",
          optionData: [
            {
              value: 1,
              label: "基本信息"
            },
            {
              value: 2,
              label: "体格"
            },
            {
              value: 3,
              label: "检查"
            },
            {
              value: 4,
              label: "检验"
            },
            {
              value: 5,
              label: "病史"
            }
            // {
            //   value: 6,
            //   label: "药品"
            // }
          ]
        },
        {
          label: "标准层级",
          value: 6,
          paramName: "parentName",
          inputType: "input"
        },
        {
          label: "申请时间",
          value: 7,
          paramName: "timeRange",
          inputType: "datetimerange",
          paramstartTime: "startTime",
          paramEndTime: "endTime"
        },
        {
          label: "状态",
          value: 8,
          paramName: "state",
          inputType: "select",
          optionData: [
            { value: "draft", label: "待审核" },
            { value: "added", label: "已添加" },
            { value: "merged", label: "已合并" }
          ]
        }
      ],
      termTypeList: [
        { label: "数字", value: "number" },
        { label: "文本", value: "string" },
        { label: "日期", value: "date" }
      ],
      positionList: [
        { label: "病人管理 - 基本信息", value: 1 },
        { label: "标准数据库-检查", value: 2 },
        { label: "标准数据库-检验", value: 3 },
        { label: "病人管理-病史信息", value: 4 }
        // { label: "标准数据库-药品", value: 5 }
      ],
      pointList: [
        { label: "1位", value: 1 },
        { label: "2位", value: 2 },
        { label: "3位", value: 3 },
        { label: "4位", value: 4 },
        { label: "5位", value: 5 },
        { label: "6位", value: 6 }
      ],
      unitList: [],
      ruleForm: {
        name: '',
        unit: '',
        unit1: "",
        regionId: "",
        positionId: '',
        recordType: '',
        parentId: '',
        result: '',
        parentName: '',
        accuracy: 2,
        referenceMin: '',
        referenceMax: ''
      },
      levelList: [],
      rules: {
        name: [
          { required: true, message: "请输入术语名", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度请限制在30字符以内!",
            trigger: "blur"
          }
        ],
        regionId: [
          { required: true, message: "请选择标准域", trigger: "change" }
        ],
        positionId: [
          { required: true, message: "请选择添加位置", trigger: "change" }
        ],
        parentId: [
          { required: true, message: "请选择标准层级", trigger: "change" }
        ],
        recordType: [
          { required: true, message: "请选择术语类型", trigger: "change" }
        ],
        accuracy: [
          { required: true, message: "请选择术语小数点", trigger: "change" }
        ],
        unit: [{ required: true, message: "请选择术语单位", trigger: "change" }],
        // referenceMin: [{ required: true, message: "请输入最低值", trigger: "change" }]
      },

      //测试
      codeLoading: false,

      crossTermsList: [],
      total: 0,
      current: 1,
      size: 10,

      parentId: null,
      regionId: null,
      codePage: {
        current: 1,
        size: 10
      },
      tempAddTermsList: [],
      selectRowIndex: ''
    }
  },
  watch: {
    "ruleForm.regionId": {
      //添加
      handler(newval) {
        if (newval) {
          this.regionId = newval;
          this.parentId = this.ruleForm.parentId;
          this.codePage.current = 1
          this.getMergeLeveList();
        }
      },
      immediate: true
    }
  },
  filters: {
    filtersRecordType(val) {
      if (val == "number") {
        return "数字";
      } else if (val == "string") {
        return "文本";
      } else {
        return "日期";
      }
    },
    filtersPostionType(val) {
      if (val == 1) {
        return "病人管理 - 基本信息";
      } else if (val == 2) {
        return "标准数据库-检查";
      } else if (val == 3) {
        return "标准数据库-检验";
      } else if (val == 4) {
        return "病人管理-病史信息";
      } else if (val == 5) {
        return "标准数据库-药品";
      } else {
        return "/";
      }
    }
  },
  async created() {
    this.getTermUnitList();
  },
  mounted() {},
  methods: {
    changeTermUnit(val) {
      if (val == '无') {
        this.ruleForm.referenceMax = ''
        this.ruleForm.referenceMin = ''
      }
    },
    onChangeRecordType() {
      this.ruleForm.unit = ''
      this.ruleForm.unit1 = ''
      this.ruleForm.referenceMin = ''
      this.ruleForm.referenceMax = ''
    },
    handleTabClick() {
      if (this.activeName == 'second') {
        this.getTerminologyList()
      }
      if (this.activeName == 'first') {
        this.crossTermsList = this.tempAddTermsList
      }
    },
    handleChangeLevel(val) {
      this.ruleForm.twoLayersName = val.twoLayersName
      this.ruleForm.parentId = val.id
    },
    getTermUnitList() {
      unitListData().then(res => {
        this.unitList = res.data
      })
    },
    getMergeLeveList(key) {
      let params = Object.assign(
        {},
        { name: this.keyWord ? JSON.parse(this.keyWord) : "" },
        this.codePage
      );
      //根据标准域获取标准层级（添加、合并）
      params.regionId = this.regionId;
      params.leaf = false;
      params.firstId = this.parentId;
      if (this.regionId == 3) {
        params.level = 3
      }
      if (this.regionId == 4) {
        params.level = 1
      }
      if (key) {
        this.levelList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        termListData(params).then(res => {
          this.codeLoading = false;
          this.pages = res.data.total;
          this.levelList = this.levelList.concat(res.data.records);
        });
      }, 200);
    },
    handleEdit(row,index) {
      this.ruleForm = DEEP_CLONE(row)
      this.parentObj = {
        id: this.ruleForm.parentId,
        name: this.ruleForm.twoLayersName
      }
      this.selectRowIndex = index
    },
    handleCurrentChange(value) {
      this.current = value;
      this.getTerminologyList();
    },
    handleSizeChange(value) {
      this.size = value;
      this.getTerminologyList();
    },
    codeRemoteMethod(query) {
      this.keyWord = JSON.stringify(query);
      this.codePage.current = 1;
      this.getMergeLeveList(true);
    },
    //切换标准域
    onChangeRegion(val) {
      this.parentObj = {}
      if (val == 1) {
        this.ruleForm.positionId == 1;
      } else {
        this.ruleForm.positionId = val - 1;
      }
      this.levelList = [];
      this.ruleForm.parentId = "";
    },
    //根据标准域获取标准层级
    loadmore() {
      this.codePage.current++;
      if (this.codePage.current > this.pages) {
        return;
      }
      this.getMergeLeveList();
    },

    async getTerminologyList() {
      let res = await pageTerminologyList({
        patientFilesItemId: this.patientFilesItemId,//点击哪个对照录入文件进来的  id
        current: this.current,
        size: this.size,
        rwsData: true
      })
      if (res.code === 0) {
        this.crossTermsList = res.data.records
        this.total = res.data.total
      }
    },
    // 保存
    async handleSave() {
      let tempList = DEEP_CLONE(this.crossTermsList)
      tempList.map(v => {
        v.unit = `${v.unit}${v.unit1 ? '/' + v.unit1 : ''}`
      })
      let res = await insertTerminologyList(tempList)
      if (res.code === 0) {
        this.$message.success('保存成功')
        this.tempAddTermsList = []
        this.activeName = 'second'
        this.getTerminologyList()
      }
    },
    handleReset() {
      // this.ruleForm = {
      //   unit1: "",
      //   regionId: "",
      //   parentId: '',
      //   result: '',
      //   parentName: ''
      // }
      this.$refs.addTermForm.resetFields()
      this.ruleForm.referenceMax = ''
      this.ruleForm.unit1 = ''
      this.parentObj = {}
    },
    handleAdd() {
      let valRes
      this.$refs.addTermForm.validate(val => {
        valRes = val
      })
      if (!valRes) {
        return
      }
      // if (this.ruleForm.recordType == 'number') {
      //   // if (this.ruleForm.accuracy == 1) {
      //   //   let reg1 = /^\d*\.\d{1}$/
      //   //   if (this.ruleForm.referenceMin && !reg1.test(this.ruleForm.referenceMin)) {
      //   //     this.$message.error('术语单位参考值最低值须保留一位小数')
      //   //     return
      //   //   }
      //   //   if (this.ruleForm.referenceMax && !reg1.test(this.ruleForm.referenceMax)) {
      //   //     this.$message.error('术语单位参考值最高值须保留一位小数')
      //   //     return
      //   //   }
      //   // } else {
      //   //   let reg2 = /^\d*\.\d{2}$/
      //   //   if (this.ruleForm.referenceMin && !reg2.test(this.ruleForm.referenceMin)) {
      //   //     this.$message.error('术语单位参考值最低值须保留两位小数')
      //   //     return
      //   //   }
      //   //   if (this.ruleForm.referenceMax && !reg2.test(this.ruleForm.referenceMax)) {
      //   //     this.$message.error('术语单位参考值最高值须保留两位小数')
      //   //     return
      //   //   }
      //   // }
      // }

      if(this.ruleForm.recordType == 'number' && this.ruleForm.unit !='无'){
        if(this.ruleForm.referenceMin){
          if(!/^\d+(\.\d+)?$/.test(this.ruleForm.referenceMin)){
            return this.$message.error("当前参考范围值不合理");
          }
          if (String(this.ruleForm.referenceMin).split(".").length) {
            if (
              String(this.ruleForm.referenceMin).split(".").length == 2 &&
              String(this.ruleForm.referenceMin).split(".")[1].length > this.ruleForm.accuracy
            ) {
              return this.$message.error("当前参考范围值不合理");
            }
          }
          
        }
        if(this.ruleForm.referenceMax){
          if(!/^\d+(\.\d+)?$/.test(this.ruleForm.referenceMax)){
            return this.$message.error("当前参考范围值不合理");
          }
          if (String(this.ruleForm.referenceMax).split(".").length) {
            if (
              String(this.ruleForm.referenceMax).split(".").length == 2 &&
              String(this.ruleForm.referenceMax).split(".")[1].length > this.ruleForm.accuracy
            ) {
              return this.$message.error("当前参考范围值不合理");
            }
          }
        }
      }
      
      if (!this.ruleForm.parentId) {
        this.$message.error('请选择标准层级')
        return
      }
      this.activeName = 'first'
      this.ruleForm.patientFilesItemId = this.patientFilesItemId
      if (this.selectRowIndex !== '') {
        // 编辑
        this.tempAddTermsList.splice(this.selectRowIndex, 1, DEEP_CLONE(this.ruleForm))
      } else {
        // 新增
        this.tempAddTermsList.unshift(DEEP_CLONE(this.ruleForm))
      }
      this.crossTermsList = this.tempAddTermsList
      this.$refs.addTermForm.resetFields()
      this.ruleForm.referenceMax = ''
      this.ruleForm.unit1 = ''
      // this.ruleForm = {
      //   unit1: "",
      //   regionId: "",
      //   parentId: '',
      //   result: '',
      //   parentName: ''
      // }
      this.parentObj = {}
      this.selectRowIndex = ''
      this.levelList = []
    },
    // handleBottomAdd() {
    //   this.ruleForm = {
    //     unit1: "",
    //     regionId: "",
    //     parentId: '',
    //     result: '',
    //     parentName: ''
    //   }
    //   this.parentObj = {}
    //   this.selectRowIndex = ''
    // }
  },
};
</script>
<style lang="less" scoped>
.add-terms-wrapper {
  position: relative;
  height: 100%;
  /deep/.el-table td, .el-table th {
    // padding: 6px 0;
  }
  .add-item-push {
    width: 95%;
    background-color: #fcfcfc;
    border: 1px dashed #d9d9d9;
    color: #333333;
    // margin-bottom: 20px;
    text-align: center;
    margin-top: 20px;
  }
  .add-terms-tips {
    // width: 821px;
    height: 40px;
    background: #FFFBE6;
    border-radius: 2px;
    border: 1px solid #FFE58F;
    // text-align: center;
    margin-bottom: 20px;
    margin-top: 20px;
    padding-left: 16px;
    // width: 749px;

    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 40px;
  }
  /deep/.el-select {
    width: 100%;
  }
  .refer-unit-value {
    display: flex;
    align-items: center;
    border-radius: 4px;
    height: 36px;
    border: 1px solid #D9D9D9;
    box-sizing: border-box;
    /deep/.el-input__inner {
      border: 0;
    }
  }
  .save-btn {
    // text-align: center;
    margin-top:10px;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
